import { LinksApiResponse } from 'features/Redirects'
import { useQuery } from 'react-query'

import { API_ENDPOINTS } from 'config/api'
import axios from 'config/axios'

export const fetchLinkDetails = async (key: string) => {
  const response = await axios.get(`${API_ENDPOINTS.LINK}/${key}`)
  const data = response.data as LinksApiResponse
  return { ...data.data.attributes, id: data.data.id }
}

/**
 * To get the redirect path for a link
 */
export const useLinkDetails = (key: string) => {
  return useQuery('linkDetails', () => fetchLinkDetails(key), {
    enabled: !!key
  })
}
